import * as React from "react";
import { navTo } from "@origin-digital/event-dispatcher";
import {
  Stack,
  Heading,
  Button,
  Text,
  MarkdownLite,
  Columns,
  Column,
} from "@origin-digital/ods-core";
import { SpotChatIcon } from "@origin-digital/icon";
import content from "../../cms/chat.json";
import { AsyncMessenger } from "./AsyncMessenger";

interface IChatProps {
  isNative: boolean;
  isRxCustomer: boolean;
  nativeChatSupported: boolean | undefined;
}

const LiveChatSection = (): JSX.Element => {
  const { contactUs } = content;
  return (
    <>
      <Stack alignX={["left", "center"]}>
        <SpotChatIcon size={96} />
        <Heading variant="h3">{contactUs.title}</Heading>
        <Stack space="none" alignX={["left", "center"]}>
          <Text>
            <MarkdownLite>{`${contactUs.line1}`}</MarkdownLite>
          </Text>
          <Text>{contactUs.line2}</Text>
        </Stack>
        <Button
          data-id="contact-us-button"
          onClick={() => {
            navTo.contactUs();
          }}
        >
          {contactUs.button}
        </Button>
      </Stack>
    </>
  );
};

const PhoneAndEmailSection = ({
  isRxCustomer,
}: {
  isRxCustomer: boolean;
}): JSX.Element => {
  const { phone, r1Email, rxEmail } = content.phoneOrEmail;
  const emailText = isRxCustomer ? rxEmail : r1Email;
  return (
    <Columns
      alignX={["left", "center"]}
      collapseBelow="lg"
      data-id="chat-item-other"
    >
      <Column width="2/3">
        <Stack alignX={["left", "center"]}>
          <Text align={["left", "center"]}>
            <MarkdownLite>{`${phone}${emailText}`}</MarkdownLite>
          </Text>
        </Stack>
      </Column>
    </Columns>
  );
};

export const Chat = (chatProps: IChatProps): JSX.Element => {
  const { nativeChatSupported, isRxCustomer, isNative } = chatProps;
  const { heading } = content;
  return (
    <>
      {nativeChatSupported && <AsyncMessenger />}
      <Columns
        alignX={["left", "center"]}
        collapseBelow="lg"
        space={["none", "xxxlarge"]}
        data-id="chat"
      >
        <Column width="2/3">
          <Stack alignX={["left", "center"]} space={["xlarge", "xlarge"]}>
            <Heading variant="h3">{heading}</Heading>
            <Stack space={["xlarge", "xxlarge"]}>
              {!isNative && <LiveChatSection />}
              {isNative && <PhoneAndEmailSection isRxCustomer={isRxCustomer} />}
            </Stack>
          </Stack>
        </Column>
      </Columns>
    </>
  );
};
